import { useEffect } from 'react';

export const useTrackingPreferenceModal = (
  observerKey: string,
  customCTAClassName: string,
  trackingPreferenceCTAId: string,
  trackingPreferenceCloseButtonId: string
) => {
  useEffect(() => {
    let scrollPosition = 0;

    const openTrackingPreferenceModal = (event: Event) => {
      event.preventDefault();
      scrollPosition = window.scrollY;
      const trackingPreferenceLink = document.getElementById(trackingPreferenceCTAId) as HTMLAnchorElement | null;
      trackingPreferenceLink?.click();
    };

    const handleModalClose = () => {
      setTimeout(() => {
        window.scrollTo({ top: scrollPosition, behavior: 'auto' });
      }, 0);
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleModalClose();
      }
    };

    const trackingPrefLinks = document.querySelectorAll<HTMLAnchorElement>(`.${customCTAClassName}`);
    trackingPrefLinks.forEach(trackingPref => trackingPref.addEventListener('click', openTrackingPreferenceModal));

    document.addEventListener('keydown', handleKeyDown);

    // we need to use MutationObserver since OneTrust Javascript is loaded async and the Modal is getting
    // created after the react component gets rendered.
    const observer = new MutationObserver(() => {
      const closeButton = document.getElementById(trackingPreferenceCloseButtonId);
      if (closeButton) {
        closeButton.addEventListener('click', handleModalClose);
        observer.disconnect(); // Stop observing once the button is found
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      trackingPrefLinks.forEach(trackingPref => trackingPref.removeEventListener('click', openTrackingPreferenceModal));
      document.removeEventListener('keydown', handleKeyDown);
      observer.disconnect();

      const closeButton = document.getElementById(trackingPreferenceCloseButtonId);
      closeButton?.removeEventListener('click', handleModalClose);
    };
  }, [observerKey, customCTAClassName, trackingPreferenceCTAId, trackingPreferenceCloseButtonId]);
};
